import React, { useState, useEffect } from 'react';
import SwipeableViews from 'react-swipeable-views'; //paquete installado manual(npm i react-swipeable-views)
import { makeStyles, useTheme } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Resumen from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Resumen/Resumen.js';
import Accounting from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Accounting/Accounting.js';
import Address from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Address.js';
import Contact from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Contact.js';
import Document from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Document.js';
import Order from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Order.js';
import NoOrder from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/NoOrder.js';
import OrderSAP from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/OrderSAP.js';
import Receivable from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Receivable.js';
import Sale from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Sale.js';
import Bureau from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Bureau.js';
/* import PaymentBureau from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/PaymentBureau.js'; */
import CreditNote from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/CreditNote.js';
import Mark from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/BusinessPartnerDetail/Mark.js';
import NewBpartner from 'components/Tvendo/BusinessPartner/DataMaster/BusinessPartner/NewBpartner/NewBpartner.js';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Fragment } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';

import { Toasty, useToasty } from 'hooks/Toasty';
import { wsGet, wsRemove } from 'services/WService.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
//Tabs
import { TabPanel, indexTab, useStyleTabs } from 'hooks/TabPanel';
import { useAuth } from 'hooks/useAuth';
import Badge from 'components/Badge/Badge';

const useStyles = makeStyles(styles);

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function () {
  const classes = useStyles();
  const claseStyleTab = useStyleTabs();
  const queryType = useQuery().get('type');
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [value, setValue] = useState(0);
  const [notify, showNotify] = useToasty();

  const [businessPartner, setBusinessPartner] = useState({});

  const themeTab = useTheme();
  const { hasPermission } = useAuth();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleChangeIndex = (index) => {
    setValue(index);
  };

  //#region --- funcion para mostrar alert de confirmacion al eliminar
  const [alert, setAlert] = useState(null);
  const hideAlert = () => {
    setAlert(null);
  };
  function confirmDelete(entity, id, fnSuccess = null) {
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="¿Está seguro de eliminar?"
        onConfirm={() => {
          remove(entity, id, fnSuccess);
          hideAlert();
        }}
        onCancel={() => hideAlert()}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      />
    );
  }

  async function remove(entity, id, fnSuccess) {
    let response = await wsRemove(entity, id);
    if (response.success) {
      showNotify(response.message);
      getBusinessPartner();
      if (typeof fnSuccess === 'function') fnSuccess();
    } else {
      showNotify(response.message, 'error');
    }
  }
  //#endregion

  async function getBusinessPartner() {
    let response = await wsGet('base/business-partner', id);
    if (response.success) setBusinessPartner(response.data);
  }

  const tabsComponent = [
    // type se usa para condicionar si mostrar o no
    // T = Todos (no importa si es proveedor o cliente)
    // C = Solo Clientes
    // P = Solo Proveedores
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_SUMMARY_SHOW,
      component: Resumen,
      label: 'Resumen',
      hash: 'resumen'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ACCOUNTING_SHOW,
      component: Accounting,
      label: 'Contabilidad',
      hash: 'contabilidad'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_SHOW,
      component: Address,
      label: 'Direcciones',
      hash: 'direcciones'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_SHOW,
      component: Contact,
      label: 'Contactos',
      hash: 'contactos'
    },
    {
      type: 'C',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_BUREAU_SHOW,
      component: Bureau,
      label: 'Mesa',
      hash: 'mesa'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_DOCUMENT_SHOW,
      component: Document,
      label: 'Documentos',
      hash: 'documentos'
    },
    {
      type: 'C',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ORDER_SHOW,
      component: Order,
      label: 'Pedidos',
      hash: 'pedidos'
    },
    {
      type: 'C',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ORDER_SHOW,
      component: NoOrder,
      label: 'No pedidos',
      hash: 'no-pedidos'
    },
    {
      type: 'C',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_ORDER_SAP_SHOW,
      component: OrderSAP,
      label: 'Pedidos SAP',
      hash: 'pedidos-sap'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_CXC_SHOW,
      component: Receivable,
      label: businessPartner.CardType === 'C' ? 'CxC' : 'CxP',
      hash: 'cuentas'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_SALE_SHOW,
      component: Sale,
      label: businessPartner.CardType === 'C' ? 'Ventas' : 'Compras',
      hash: 'v-c'
    },
    {
      type: 'T',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_NC_SHOW,
      component: CreditNote,
      label: 'Nc',
      hash: 'notas-credito'
    },
    {
      type: 'S',
      permission: ConstantPermissions.BASE_BUSINESS_PARTNERS_PROVIDER_MARK_SHOW,
      component: Mark,
      label: 'Marcas',
      hash: 'marcas'
    }
  ];

  useEffect(() => {
    let activeTabIndex = tabsComponent.findIndex((tabItem) => `#${tabItem.hash}` === location.hash);
    if (activeTabIndex !== -1) {
      setValue(activeTabIndex);
    }
    getBusinessPartner();
  }, []);

  function changeHash(hash) {
    navigate(`${location.pathname}#${hash}`, { replace: true });
  }

  return (
    <Fragment>
      <Toasty action={notify} />
      {alert}
      {id != 0 ? (
        <Fragment>
          <h4 style={{ fontWeight: 'bold' }}>
            {businessPartner.CardCode} -- {businessPartner.CardName}{' '}
            {businessPartner.DocEntry !== null ? (
              <Badge color="success">Ok</Badge>
            ) : (
              <Badge color="danger">No migrado</Badge>
            )}
          </h4>
          <div className={claseStyleTab.root}>
            <AppBar position="static" color="default">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                textColor="secondary"
                aria-label="Tabs"
                indicatorColor="secondary"
              >
                {!!businessPartner ? (
                  tabsComponent
                    .filter(
                      (item) =>
                        (item.type === businessPartner.CardType || item.type === 'T') &&
                        hasPermission(item.permission),
                    )
                    .map((item, i) => {
                      return (
                        <Tab
                          label={item.label}
                          {...indexTab(i)}
                          key={i}
                          onClick={() => changeHash(item.hash)}
                        />
                      );
                    })
                ) : (
                  <></>
                )}
              </Tabs>
            </AppBar>

            <SwipeableViews
              axis={themeTab.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              {!!businessPartner ? (
                tabsComponent
                  .filter(
                    (item) =>
                      (item.type === businessPartner.CardType || item.type === 'T') &&
                      hasPermission(item.permission),
                  )
                  .map((item, i) => {
                    return (
                      <TabPanel key={i} value={value} index={i} dir={themeTab.direction}>
                        <item.component
                          businessPartner={{ id, ...businessPartner }}
                          reload={getBusinessPartner}
                          showNotify={showNotify}
                          confirmDelete={confirmDelete}
                        />
                      </TabPanel>
                    );
                  })
              ) : (
                <></>
              )}
            </SwipeableViews>
          </div>
        </Fragment>
      ) : (
        <NewBpartner
          businessPartner={businessPartner}
          reload={getBusinessPartner}
          queryType={queryType}
        />
      )}
    </Fragment>
  );
}
